import { boot } from "quasar/wrappers";
import PageLoadSpinner from "../components/PageLoadSpinner.vue";
import PageLoadError from "../components/PageLoadError.vue";
import DEVJsonFormat from "../components/DEVJsonFormat.vue";
import CustomerIdComponent from '../components/CustomerIdComponent.vue';

export default boot(({ app }) => {
  app.component("PageLoadSpinner", PageLoadSpinner);
  app.component("PageLoadError", PageLoadError);
  app.component("DEVJsonFormat", DEVJsonFormat);
  app.component("CustomerIdComponent",CustomerIdComponent);
});
